import { APIService } from "../../../../../../../../network/api/APIService";

export const ProductD = (app_id, slug) => {
    const endpoint = `/shop/api/products/item/?app_id=${app_id}&slug=${slug}`;

    return APIService({
        endpoint: endpoint,
        method: "GET",
        credentials: "include"
    });
};